module.exports = __webpack_public_path__ + "static/media/logo.0e56000d.svg";